import React, { useMemo } from 'react'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { FormBaseFieldSubEntity } from './form-base-field-sub-entity'
import { FormCountryFieldSubEntity } from './form-country-field-sub-entity'
import { FormEmailFieldSubEntity } from './form-email-field-sub-entity'
import { FormPhoneNumberFieldSubEntity } from './form-phone-number-field-sub-entity'

interface FormFieldSubEntityProps {
  formEntity: FormInterface
  fieldSubEntity: FormFieldInterface
}

export const FormFieldSubEntity = ({
  formEntity,
  fieldSubEntity,
}: FormFieldSubEntityProps) => {
  const fieldWithCommonProps = useMemo(
    () => ({
      ...fieldSubEntity,
      ...formEntity.fieldsCommonStyles,
    }),
    [fieldSubEntity, formEntity.fieldsCommonStyles],
  )
  switch (fieldSubEntity.slug) {
    case ContactSlugEnum.Email:
      return <FormEmailFieldSubEntity fieldSubEntity={fieldWithCommonProps} />
    case ContactSlugEnum.Country:
      return <FormCountryFieldSubEntity fieldSubEntity={fieldWithCommonProps} />
    case ContactSlugEnum.PhoneNumber:
      return (
        <FormPhoneNumberFieldSubEntity fieldSubEntity={fieldWithCommonProps} />
      )
    default:
      return <FormBaseFieldSubEntity fieldSubEntity={fieldWithCommonProps} />
  }
}
